import {Popover} from '@ariakit/react'
import styled, {css} from 'styled-components'
import {Root as RadioGroupRoot, Item as RadioGroupItem} from '@radix-ui/react-toggle-group'

export const StyledDateRangeFilterPopover = styled(Popover)(
    ({theme: {palette, zIndex, shadows}}) => css`
        background-color: ${palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${shadows.lg};
        border: 1px solid ${palette.neutral[200]};
        z-index: ${zIndex.dropdown};
    `
)

export const StyledDateRangeFilterPopoverContent = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        gap: ${spacing * 6}px;
        min-height: 400px;
        min-width: 380px;
    `
)

export const StyledDateRangeFilterPopoverContentHeader = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: ${spacing * 4}px;
        padding: ${spacing * 3}px ${spacing * 3}px 0 ${spacing * 3}px;
    `
)

export const StyledDateRangeFilterYearSelector = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 3}px;
        width: 100%;
        justify-content: space-between;
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        padding: ${spacing}px;
    `
)

export const StyledDateRangeFilterFooter = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${spacing * 3}px;
        border-top: 1px solid ${palette.neutral[200]};
    `
)

export const StyledDateRangeMonthRadioGroup = styled(RadioGroupRoot)(
    ({theme: {spacing}}) => css`
        width: 100%;
        padding: 0 ${spacing * 3}px;
    `
)

export const StyledDateRangeMonthRadioItem = styled(RadioGroupItem)<{
    $isSelected: boolean
    $isDisabled?: boolean
}>(
    ({theme: {palette, spacing, transition, typography, shadows}, $isSelected, $isDisabled}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 38px;
        padding: ${spacing * 2}px;
        border-radius: 8px;
        border: 1px solid ${$isSelected ? palette.primary[300] : palette.neutral[300]};
        background-color: ${$isSelected ? palette.primary[50] : palette.neutral.white};
        color: ${$isSelected ? palette.primary[600] : palette.neutral[900]};
        cursor: ${$isDisabled ? 'not-allowed' : 'pointer'};
        transition: ${transition};
        font-size: ${typography.textSm};
        box-shadow: ${shadows.sm};
        ${$isDisabled &&
        css`
            opacity: 0.5;
        `}

        &:hover {
            ${!$isDisabled &&
            css`
                box-shadow: ${`${shadows.sm}, 0px 0px 0px 4px ${palette.primary[100]}`};
            `}
        }
    `
)
